import { HttpRequestOptions } from 'element-ui/types/upload'

export const createProcessHandler = (option: HttpRequestOptions) => (
  e: any
) => {
  option.onProgress({
    ...e,
    percent: Math.round((e.loaded * 100) / e.total)
  })
}
